import { render, staticRenderFns } from "./gruppen.vue?vue&type=template&id=1e231bde&"
import script from "./gruppen.vue?vue&type=script&lang=js&"
export * from "./gruppen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports